<template>
  <div>
    <v-layout>
      <v-flex>
        <h3 class="headline" style="display: inline">{{ $t('Multiple greeting choices') }}</h3>
        <div class="mb-2">
          {{
            $t(
              'Selecting messages can be determined to display as buttons on welcome message, which allows to create a maximum of 5 buttons.'
            )
          }}
        </div>
        <div class="small mb-2">
          {{
            $t(
              'Multiple greeting choices will be displayed for new users only. If you want to test, you have to delete a conversation on Facebook messenger before testing.'
            )
          }}
        </div>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!isEdit" @click="isEdit = !isEdit">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 md6 class="pa-1">
        <v-card>
          <template v-for="(iceitem, iceindex) in icebreaker">
            <v-card-text class="py-1" :key="iceindex">
              <v-layout>
                <v-flex class="mt-2 mb-2">
                  {{ iceitem.question }}
                </v-flex>
                <template v-if="isEdit">
                  <edit-ice-breaker
                    v-model="icebreaker[iceindex]"
                    @onSave="editNewIceBreaker(iceindex, $event)"
                    :key="iceindex + '_' + icebreaker.question"
                  ></edit-ice-breaker>
                </template>

                <v-btn
                  fab
                  small
                  flat
                  class="ma-0"
                  v-if="isEdit"
                  :disabled="icebreaker.length <= 1"
                  @click="icebreaker.splice(iceindex, 1)"
                  ><v-icon small>delete</v-icon></v-btn
                >
              </v-layout>
            </v-card-text>
            <v-divider :key="'divider_' + iceindex"></v-divider>
          </template>
        </v-card>
        <template v-if="icebreaker.length < 5">
          <add-ice-breaker
            class="mt-3"
            v-if="isEdit"
            @onSave="addNewIceBreaker"
            v-model="newIceBreaker"
          >
          </add-ice-breaker>
        </template>

        <div class="text-xs-center mt-2" v-if="isEdit">
          <v-btn color="grey" outline @click="onCancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
        </div>
      </v-flex>
      <v-flex xs12 md6 class="pa-1">
        <facebook-screen :pagename="selectedBot.pagename" @onScroll="onScroll">
          <div slot="body" style="position: relative;">
            <div
              class="ma-2 py-1 px-3"
              style="background: #f5f6f7; border: 1px solid #dadde1; border-radius: 10px;"
            >
              <template v-for="(iceitem, iceindex) in icebreaker">
                <div class="py-1" :key="iceindex">
                  <v-layout>
                    <v-flex class="mt-2 text-xs-left black--text">
                      {{ iceitem.question }}
                    </v-flex>
                    <v-btn
                      small
                      style="border-radius: 50px; min-width: auto;text-transform: capitalize;"
                      class="mx-0 pa-2 font-weight-bold"
                      color="#ebedf0"
                      depressed
                      readonly
                    >
                      Ask
                    </v-btn>
                  </v-layout>
                </div>
                <v-divider
                  v-if="iceindex != icebreaker.length - 1"
                  :key="'divider_' + iceindex"
                ></v-divider>
              </template>
            </div>
          </div>
        </facebook-screen>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FacebookScreen from '@/components/elements/FacebookScreen'
import AddIceBreaker from './AddIceBreaker'
import EditIceBreaker from './EditIceBreaker'
export default {
  props: ['value'],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    FacebookScreen,
    AddIceBreaker,
    EditIceBreaker
  },
  data() {
    return {
      icebreaker: this.value,
      isEdit: false,
      newIceBreaker: null
    }
  },
  mounted() {
    this.cached_icebreaker = JSON.stringify(this.icebreaker)
  },
  methods: {
    addNewIceBreaker(payload) {
      this.icebreaker.push(payload.icebreaker)
      payload.onClear()
    },
    editNewIceBreaker(iceindex, payload) {
      this.$set(this.icebreaker, iceindex, payload.icebreaker)
    },
    onCancel() {
      this.isEdit = false
      this.icebreaker = JSON.parse(this.cached_icebreaker)
    },
    onSave() {
      this.isEdit = false
      this.$emit('onSave', this.icebreaker)
      this.cached_icebreaker = JSON.stringify(this.icebreaker)
    },
    onScroll() {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/IceBreaker.vue